import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditProjectElementDetailsConfigurationRequest(
  state: State,
  { planzone }: Boundaries["editProjectElementDetailsConfiguration"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToPending() }];
}

function handleEditProjectElementDetailsConfigurationSuccess(
  state: State,
  { planzone }: Boundaries["editProjectElementDetailsConfiguration"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToSuccess() }];
}

function handleEditProjectElementDetailsConfigurationFailure(
  state: State,
  { planzone }: Boundaries["editProjectElementDetailsConfiguration"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.editProjectElementDetailsConfigurationRequested]:
    handleEditProjectElementDetailsConfigurationRequest,
  [events.editProjectElementDetailsConfigurationSucceeded]:
    handleEditProjectElementDetailsConfigurationSuccess,
  [events.editProjectElementDetailsConfigurationFailed]:
    handleEditProjectElementDetailsConfigurationFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
